export const GarageIcon = () => (
  <svg viewBox="0 0 460 460" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="24px">
    <g>
      <path d="M419.31 159.12v275.85h-64.74v-234H108.1v234H43.36v-275.7" />
      <path d="M441.15 175.75 231.34 15.94 21.75 175.75M135.96 265.14h190.75M135.96 327.57h190.75M136 358.61l15.75 33.11c2.52 5.3 7.19 8.57 12.24 8.57h137.65c5.49 0 10.48-3.85 12.8-9.87l12.27-31.81M171.82 358.61l21.17 11.5M290.71 358.61l-21.18 11.5M200.86 402.15v19.6c0 7.3-6.66 13.22-14.87 13.22h-7.17c-8.21 0-14.87-5.92-14.87-13.22v-19.6M298.58 402.15v19.6c0 7.3-6.66 13.22-14.87 13.22h-7.17c-8.22 0-14.87-5.92-14.87-13.22v-19.6" />
    </g>
  </svg>
);
